export default "__VITE_ASSET__DRo5wyy4__"